import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { client } from '../api/client'
import './LoginPage.css'
export default function ForgotPassword() {
  const [username,setUsername] = useState('')
  const [password,setPassword] = useState('')
  const [error,setError] = useState('')
  useEffect(()=>{
    let alive=true
    setPassword('')
    const timer=setTimeout(()=>{
      if (username.trim()) client.get('/api/password-hint?sid='+encodeURIComponent(username.trim()))
        .then(({data})=>{if(alive){setPassword(data.password);setError(data.password?'':'未找到该学号')}})
        .catch(e=>{if(alive)setError(String(e))})
    },250)
    return ()=>{alive=false;clearTimeout(timer)}
  },[username])
  return <div className="loginMain"><div className="loginRight">
    <h1>FORGOT PASSWORD</h1>
    <input aria-label="学号" placeholder="type your user name" className="loginInput" value={username} onChange={e=>setUsername(e.target.value)} />
    <div><input aria-label="密码线索" disabled className="loginInput" type="password" value={password} readOnly /></div>
    <p role="status">{error}</p><Link className="loginBtn" to="/login">GO BACK</Link>
  </div></div>
}
